import type { EvidenceSection } from 'api/brokerCases/types';
import { EvidencePage } from './EvidencePage';

interface EvidenceTabContentProps {
  caseId: string;
  sections: EvidenceSection[];
  isCaseTasksLoading: boolean;
}

export const EvidenceTabContent = ({ caseId, sections, isCaseTasksLoading }: EvidenceTabContentProps) => {
  return (
    <div className='mt-6'>
      <EvidencePage caseId={caseId} sections={sections} isCaseTasksLoading={isCaseTasksLoading} />
    </div>
  );
};
